import { AbstractControl, ValidationErrors } from '@angular/forms';

export function IbanValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = (control.value || '').trim().toUpperCase();

  const ibanRegex =
    /^[A-Za-z]{2}[0-9]{2}[A-Za-z]{1}[0-9]{5}[0-9]{5}[0-9A-Za-z]{12}$/;

  return !value || ibanRegex.test(value) ? null : { iban: true };
}
